import { ChakraProvider, DarkMode, extendTheme } from '@chakra-ui/react';
import moment from 'moment';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { Api, ApiProvider } from './hooks/Api';

import 'moment/locale/cs';
import { AppState, AppStateProvider } from './hooks/AppState';
moment.locale('cs');

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const baseURL = isLocal ? 'http://localhost:3000' : '/api';

const api = new Api(baseURL);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <ChakraProvider
        theme={extendTheme({
            styles: {
                global: {
                    body: {
                        overflowX: 'hidden',
                    },
                    html: {
                        overflowX: 'hidden',
                    },
                },
            },
        })}
    >
        <ApiProvider value={api}>
            <AppStateProvider value={new AppState(api)}>
                <DarkMode>
                    <App />
                </DarkMode>
            </AppStateProvider>
        </ApiProvider>
    </ChakraProvider>,
);
